/* global CONFIG */
import moment from 'moment'
import services from '../services'

export default {
  getInvoices (VueApp, id, callback) {
    VueApp.$sdk.get('/admin/corporateprofile/' + id + '/invoices', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        // VueApp.$store.commit('corporate/setTrxMaxList', res.paging.totalItems)

        if (res.list.length) {
          let data = res.list
          for (let i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('corporate/addInvoices', {
              id: data[i].id,
              file: data[i].fileUrl,
              startDate: moment(data[i].startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              endDate: moment(data[i].endDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              dueDate: moment(data[i].dueDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              status: data[i].status
            })
          }
        }
      }
      callback(res)
    })
  },
  getInvoiceData (VueApp, data, callback) {
    VueApp.$sdk.get('/admin/corporateprofile/' + data.corporateId + '/invoices/' + data.invoiceId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  updateFields (VueApp, data, callback) {
    VueApp.$sdk.post('/admin/corporateprofile/' + data.corporateId + '/invoices/' + data.invoiceId, {
      token: VueApp.$store.state.session.sessionToken,
      status: data.status,
      dueDate: data.dueDate
    }, res => {
      callback(res)
    })
  },
  exportTransactions (VueApp, conId, callback) {
    let self = this
    let transactions = VueApp.$store.state.corporate.transactions
    let pageSize = 99999
    let page = 1

    let since = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, res => {
      if (!res.error) {
        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value))
          })
        }
        callback(trx)
      } else {
        callback(res)
      }
    })
  },
  toFixed (value) {
    value = parseFloat(value)
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2)
    }
    return '$' + value.toFixed(2)
  },
  bookedThroughLabel (value) {
    switch (value) {
      case 'ww': return 'Web'
      case 'admin': return 'Admin'
      case 'android': return 'Android App'
      case 'ios': return 'iOS App'
      case 'provider': return 'Provider'
      default: return value
    }

    return ''
  },
  buildExport (data) {
    let rsvpId = this.convertBrand(data.brandId) + data.rsvpId
    let serviceType = services.getServiceName(data.serviceCode)
    let payment = data.payment
    let creditCard = payment.cancelFee ? 'N/A' : data.cardNumber
    let source = this.bookedThroughLabel(data.deviceType)
    let provLicense = data.provider.accountType || ''

    if (data.packageId) {
      rsvpId = data.packageId
      serviceType = services.getServiceName('shared')
      source = 'PKG'
    }
    if (!CONFIG.useOldQuatation) {
      serviceType = data.serviceType.label
    }

    return {
      Date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    }
  },
  convertBrand (id) {
    let index = CONFIG.brands.findIndex(x => x.id === id)
    if (!id || index === -1) { return CONFIG.brands[0].code.toUpperCase() }

    return CONFIG.brands[index].code.toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/corporate/invoice.js